import Banner from '../components/banner';
import Faq from '../components/faq';
import FillDetails from '../components/fillDetails';
import Services from '../components/services';
import Testimonial from '../components/testimonial';
import WhyChoose from '../components/whyChoose';

function Home({ openPopup }) {
  return (
    <div id="home">
      <Banner />
      <FillDetails />
      <WhyChoose />
      <Services openPopup={openPopup} />
      <Testimonial/>
      <Faq/>
    </div>
  );
}

export default Home;
